(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
    
  
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  <!-- customElements.define('sticky-header', StickyHeader); -->

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-category"]) return;
  try {
    
$(document).ready(function(){
  $(".dt-menu-expand").click(function(event){
    event.preventDefault();
    if( $(this).hasClass("dt-mean-clicked")){
      $(this).html('<i class="fa fa-plus"></i>');
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideUp(400);
      } else {
        $(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
      }
    } else {
     $(this).html('<i class="fa fa-minus"></i>');
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideDown(400);
      } else{
        $(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
      }
    }
    $(this).toggleClass("dt-mean-clicked");
    return false;
  });
}); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function(){
     var tvSliderSpeed = $('.tvslider-list-slider').attr('data-speed');
     var tvSliderAutoplay = $('.tvslider-list-slider').attr('data-autoplay');
     var tvSliderLoop = $('.tvslider-list-slider').attr('date-loop');
     var tvSliderHover = $('.tvslider-list-slider').attr('date-hover');
     $('.tvslider-list-slider').owlCarousel({
       dots: true,
       nav: false,
       loop: tvSliderLoop,
       autoplay: tvSliderAutoplay,
       autoplayTimeout: tvSliderSpeed,
       autoplayHoverPause: tvSliderHover,
       autoHeight: true,
       responsive: {
         0: { items: 1 },
         320: { items: 1, slideBy: 1 },
         400: { items: 1, slideBy: 1 },
         575: { items: 1, slideBy: 1 },
         768: { items: 1, slideBy: 1 },
         992: { items: 1, slideBy: 1 },
         1200: { items: 1, slideBy: 1 },
         1600: { items: 1, slideBy: 1 },
         1800: { items: 1, slideBy: 1 }
       },
     });
     $('.tvslider-slider-prev').click(function(e) {
       e.preventDefault();
       $('.tvslider .owl-nav .owl-prev').trigger('click');
     });

     $('.tvslider-slider-next').click(function(e) {
       e.preventDefault();
       $('.tvslider .owl-nav .owl-next').trigger('click');
     });
  setTimeout(function() {
  	$(".tvslider").css("height", "auto");
     }, 1000);
   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tvbrandlist"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.tvbrandlist-list-slider').owlCarousel({
      loop: true,
      dots: false,
      nav: false,
      autoplay:true,
      autoplayTimeout:9000,
      autoplayHoverPause:true,
      responsive: {
        0: { items: 1},
        320:{ items: 2, slideBy: 2},
        400:{ items: 2, slideBy: 1},
        768:{ items: 3, slideBy: 1},
        992:{ items: 4, slideBy: 1},
        1200:{ items: 5, slideBy: 1},
        1600:{ items: 5, slideBy: 1},
        1800:{ items: 5, slideBy: 1}
      },
    });
    $('.tvbrandlist-slider-prev').click(function(e) {
      e.preventDefault();
      $('.tvbrandlist .owl-nav .owl-prev').trigger('click');
    });

    $('.tvbrandlist-slider-next').click(function(e) {
      e.preventDefault();
      $('.tvbrandlist .owl-nav .owl-next').trigger('click');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tvcategorychainslider"] && !Shopify.designMode) return;
  try {
    

	$(document).ready(function(){
    $('.tvcategorychainslider-list-slider').owlCarousel({
      loop: true,
      dots: false,
      nav: false,
      autoplay:true,
      autoplayTimeout:9000,
      autoplayHoverPause:true,
      responsive: {
        0: { items: 1 },
        320: { items: 1, slideBy: 1 },
        400: { items: 2, slideBy: 1 },
        575: { items: 3, slideBy: 1 },
        768: { items: 3, slideBy: 1 },
        992: { items: 3, slideBy: 1 },
        1200: { items: 4, slideBy: 1 },
        1600: { items: 4, slideBy: 1 },
        1800: { items: 4, slideBy: 1 }
      },
    });
    $('.tvcategorychainslider-slider-prev').click(function(e) {
      e.preventDefault();
      $('.tvcategorychainslider .owl-nav .owl-prev').trigger('click');
    });

    $('.tvcategorychainslider-slider-next').click(function(e) {
      e.preventDefault();
      $('.tvcategorychainslider .owl-nav .owl-next').trigger('click');
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tvcategoryslider"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.tvcategoryslider-list-slider').owlCarousel({
      loop: true,
      dots: false,
      nav: false,
      autoplay: false,
      autoplayTimeout: 9000,
      autoplayHoverPause: true,
      responsive: {
         0: { items: 1},
        320:{ items: 1, slideBy: 1},
        425:{ items: 2, slideBy: 1},
        525:{ items: 2, slideBy: 1},
        650:{ items: 3, slideBy: 1},
        850:{ items: 3, slideBy: 1},
        992:{ items: 4, slideBy: 1},
        1141:{ items: 4, slideBy: 1},
        1280:{ items: 4, slideBy: 1},
        1600:{ items: 5, slideBy: 1},
        1800:{ items: 5, slideBy: 1}
      },
    });
    $('.tvcategoryslider-slider-prev').click(function(e) {
      e.preventDefault();
      $('.tvcategoryslider .owl-nav .owl-prev').trigger('click');
    });

    $('.tvcategoryslider-slider-next').click(function(e) {
      e.preventDefault();
      $('.tvcategoryslider .owl-nav .owl-next').trigger('click');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tvheader"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tvimage-gallery"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.tvimage-gallery-list-slider').owlCarousel({
      loop: false,
      dots: false,
      nav: false,
      autoplay: false,
      autoplayTimeout: 1000,
      autoplayHoverPause: true,
      responsive: {
        0: { items: 1 },
        320: { items: 1, slideBy: 2 },
        400: { items: 1, slideBy: 1 },
        525: { items: 2, slideBy: 1 },
        768: { items: 2, slideBy: 1 },
        992: { items: 3, slideBy: 1 },
        1200: { items: 3, slideBy: 1 },
        1600: { items: 4, slideBy: 1 },
        1800: { items: 4, slideBy: 1 }
      },
    });
    $('.tvimage-gallery-slider-prev').click(function(e) {
      e.preventDefault();
      $('.tvimage-gallery .owl-nav .owl-prev').trigger('click');
    });

    $('.tvimage-gallery-slider-next').click(function(e) {
      e.preventDefault();
      $('.tvimage-gallery .owl-nav .owl-next').trigger('click');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tvtabproduct"]) return;
  try {
    
        var mobileViewSize = 991;
        $(document).ready(function() {
            /********************** Start Tab js **********************/
                
                $('.tab-index').click(function(e) {
                    $id = $(this).attr('data-tab-data');
                    $paging = $(this).attr('data-tab-paging');
                    $('.tab-index').removeClass('active in');

                    $('.tvcmstab-product').removeClass('active in');
                    $('.tvtab-pagination').removeClass('active in');

                    //$('.tvcmstab-product').hide();
                    $('.tvtab-pagination').hide();

                    $(this).addClass('active in');
                    $('#' + $id).addClass('active in');
                    $('.' + $paging + '-pagination').addClass('active').show();
                });
                $('.tvtab-pagination.active').fadeIn();
                $('.tvcmstab-title-product .tvtab-all-pagination').insertAfter('.tvtab-product-list-wrapper');
            /********************** End Tab js *****************************/
            /****************** Start Tab Product Slider Js *******************************************/
                var owlClass = [
                    //['slider className','navigation nextClass','navigation prevClass']
                    ['.tvtab-featured-product .tvproduct-wrapper-content-box', '.tvtab-featured-product-next', '.tvtab-featured-product-prev'],
                    ['.tvtab-new-product .tvproduct-wrapper-content-box', '.tvtab-new-product-next', '.tvtab-new-product-prev'],
                    ['.tvtab-special-product .tvproduct-wrapper-content-box', '.tvtab-special-product-next', '.tvtab-special-product-prev'],
                    ['.tvtab-best-seller-product .tvproduct-wrapper-content-box', '.tvtab-best-seller-product-next', '.tvtab-best-seller-product-prev'],
                ];
                for (var i = 0; i < owlClass.length; i++) {
                    var owl = $(owlClass[i][0]).owlCarousel({
                        loop: true,
                        dots: false,
                        nav: false,
                        autoplay:false,
                        autoplayTimeout:1000,
                        autoplayHoverPause:true,
                        responsive: {
                            0: { items: 1 },
                            320: { items: 1, slideBy: 1 },
                            330: { items: 2, slideBy: 1 },
                            576: { items: 2, slideBy: 1 },
                            768: { items: 3, slideBy: 1 },
                            992: { items: 4, slideBy: 1 },
                            1200: { items: 4, slideBy: 1 },
                            1340: { items: 4, slideBy: 1 },
                            1600: { items: 5, slideBy: 1 },
                            1800: { items: 5, slideBy: 1 }
                        }
                    });
                    $(owlClass[i][1]).on('click', function(e) {
                        e.preventDefault();
                        $('#' + $(this).attr('data-parent') + ' .owl-nav .owl-next').trigger('click');
                    });
                    $(owlClass[i][2]).on('click', function(e) {
                        e.preventDefault();
                        $('#' + $(this).attr('data-parent') + ' .owl-nav .owl-prev').trigger('click');
                    });
                    // $('#featuredid').insertAfter('#tvcmstab-featured-product .tvtab-featured-product');
                    // $('#newid').insertAfter('#tvcmstab-new-product .tvtab-new-product');
                    // $('#bestid').insertAfter('#tvcmstab-best-seller-product .tvtab-best-seller-product');
                    // $('#specialid').insertAfter('#tvcmstab-special-product .tvtab-special-product');
                }
            /****************** End Tab Product Slider Js *******************************************/
            /****************** Start Single Products Slider Js *******************************************/
            var swiperClass = [
                //['slider className','navigation nextClass','navigation prevClass','paging className']
                ['.tvcmsfeatured-product .tvfeatured-product-wrapper', '.tvcmsfeatured-next', '.tvcmsfeatured-prev', '.tvcmsfeatured-product'],
                ['.tvcmsnew-product .tvnew-product-wrapper', '.tvcmsnew-next', '.tvcmsnew-prev', '.tvcmsnew-product'],
                ['.tvcmsspecial-product .tvspecial-product-wrapper', '.tvcmsspecial-next', '.tvcmsspecial-prev', '.tvcmsspecial-product'],
                ['.tvcmsbest-seller-product .tvbest-seller-product-wrapper', '.tvcmsbest-seller-next', '.tvcmsbest-seller-prev', '.tvcmsbest-seller-product'],
            ];
            for (var i = 0; i < swiperClass.length; i++) {
                $(swiperClass[i][0]).owlCarousel({
                    loop: false,
                    dots: false,
                    nav: false,
                    responsive: {
                        0: { items: 1 },
                        320: { items: 1, slideBy: 1 },
                        576: { items: 2, slideBy: 1 },
                        768: { items: 3, slideBy: 1 },
                        991: { items: 3, slideBy: 1 },
                        992: { items: 3, slideBy: 1 },
                        1200: { items: 5, slideBy: 1 },
                        1600: { items: 5, slideBy: 1 },
                        1800: { items: 5, slideBy: 1 }
                    },
                });

                $(swiperClass[i][1]).on('click', function(e) {
                    e.preventDefault();
                    $('.' + $(this).attr('data-parent') + ' .owl-nav .owl-next').trigger('click');
                });
                $(swiperClass[i][2]).on('click', function(e) {
                    e.preventDefault();
                    $('.' + $(this).attr('data-parent') + ' .owl-nav .owl-prev').trigger('click');
                });
                // $(swiperClass[i][3]+' .tv-pagination-wrapper').insertAfter(swiperClass[i][3]+' .tvproduct-wrapper-content-box');
            }
            /****************** End Single Product Sliders Js *******************************************/
        });
        function ScrollExecute() {
            var scrollNode = $('#AjaxinatePagination').last();    
            var scrollURL = $('#AjaxinatePagination a.paging-link').last().attr("href");
            $.ajax({
            type: 'GET',
            url: scrollURL,
            beforeSend: function() {
                $('#AjaxinatePaginationLoading').show();
            },
            success: function(data) {
                    $("#AjaxinatePagination").show();
                    $('#AjaxinatePaginationLoading').hide();
                    var filteredData = $(data).find(".AjaxinateLoop");
                    var filteredPagingData = $(data).find("#AjaxinatePagination");
                    $(".AjaxinateLoop").append(filteredData);
                    $("#AjaxinatePagination").html(filteredPagingData[0].innerHTML);
            },
            dataType: "html"
            });
        }
        $(document).ready(function () {
            $(document).on('click','.paging-link', function(e){
                e.preventDefault();
                $("#AjaxinatePagination").hide();
                ScrollExecute();
            });
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tvtestimonial"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.tvtestimonial-slider').owlCarousel({
      loop: true,
      dots: false,
      nav: false,
      autoplay:true,
      autoplayTimeout:9000,
      autoplayHoverPause:true,
      responsive: {
        0: { items: 1 },
        320: { items: 1, slideBy: 1 },
        400: { items: 1, slideBy: 1 },
        575: { items: 1, slideBy: 1 },
        768: { items: 1, slideBy: 1 },
        992: { items: 1, slideBy: 1 },
        1200: { items: 1, slideBy: 1 },
        1600: { items: 1, slideBy: 1 },
        1800: { items: 1, slideBy: 1 }
      },
    });
    $('.tvtestimonial-slider-prev').click(function(e) {
      e.preventDefault();
      $('.tvtestimonial .owl-nav .owl-prev').trigger('click');
    });

    $('.tvtestimonial-slider-next').click(function(e) {
      e.preventDefault();
      $('.tvtestimonial .owl-nav .owl-next').trigger('click');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
	$(document).ready(function(){
		$('.tvvideo-content .fancybox').fancybox();
	});

  } catch(e) { console.error(e); }
})();
})();
